import React from 'react'

export const Button = ({
    variant = 'primary',
    className = '',
    loading = false,
    disabled = false,
    children,
    ...props
}) => {
    const base = 'inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-medium transition border disabled:opacity-50 disabled:cursor-not-allowed'

    const styles = {
        primary: 'bg-indigo-600 text-white hover:bg-indigo-700 border-indigo-600 dark:bg-indigo-500 dark:hover:bg-indigo-600 dark:border-indigo-500',
        outline: 'bg-transparent text-indigo-700 border-indigo-600 hover:bg-indigo-50 dark:text-indigo-400 dark:border-indigo-500 dark:hover:bg-indigo-950',
        ghost: 'bg-transparent text-slate-700 hover:bg-slate-100 border-transparent dark:text-slate-200 dark:hover:bg-slate-800',
        danger: 'bg-red-600 text-white hover:bg-red-700 border-red-600 dark:bg-red-500 dark:hover:bg-red-600',
    }

    return (
        <button
            className={`${base} ${styles[variant]} ${className}`}
            disabled={disabled || loading}
            {...props}
        >
            {loading && (
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
            )}
            {children}
        </button>
    )
}